export default __webpack_public_path__ + "static/media/placeHolderAvatar.d9c6b205.png";